/**
 * The heading of `/contact-us` (`components/ContactUsPage/index.tsx`): "Contact Us" and the
 * call-or-text line with the phone number for the build's company and the visitor's country,
 * from `@ryerson/common.constants` → `PhoneNumbers.PHONE_NUMBERS`.
 */
import { useApplication } from "@ryerson/frontend.application";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import React from "react";
import { content } from "./ContactUsPage.Content";
import { PhoneNumbers } from "@ryerson/common.constants";
import { Company } from "@ryerson/common.enums";

const company: Company = (process.env.NEXT_PUBLIC_COMPANY || "ryerson") as Company;

/** The page title and phone line; see the file header. */
export const ContactUsTitle: React.FC = () => {
	const { theme } = useTheme();
	const {
		localization: { country, language },
	} = useApplication();

	return (
		<>
			<Typography variant="h1" type="tertiary">
				{content[language].header}{" "}
			</Typography>
			<Typography variant="p" type="tertiary">
				{content[language].subHeader}{" "}
				<Typography size="lg" color={theme.colors.tertiary.header}>
					{PhoneNumbers.PHONE_NUMBERS[company][country].number}{" "}
				</Typography>
			</Typography>
		</>
	);
};
